import { assertCurrentBrowserSession, revokeBrowserSession } from "@/lib/browser-session";

import { auth } from "../src/lib/firebase-client";

/**
 * Shared authentication utilities for OpenAPI clients
 */

/**
 * Fetches the current user's Firebase authentication token.
 * Only works in browser context (client-side).
 * Returns empty string if no token is available or if called on server.
 */
export async function getAuthToken(): Promise<string> {
  // Only fetch token in browser context
  if (typeof window === "undefined") {
    return "";
  }

  const currentUser = auth?.currentUser;
  try {
    if (currentUser) {
      const token = await currentUser.getIdToken();
      assertCurrentBrowserSession(currentUser.uid);
      return token || "";
    }
  } catch (err) {
    const code = (err as { code?: string }).code;
    if (
      currentUser &&
      ["auth/user-disabled", "auth/user-token-expired", "auth/user-not-found"].includes(code || "")
    ) {
      await revokeBrowserSession(currentUser.uid, "session_expired");
    }
    // Never downgrade a failed or stale authenticated request to guest access.
    throw err;
  }

  return "";
}
